import { opportunityData } from "configs/opportunity.config";
import { servicingCompletedList } from "configs/proposedProject.config";
import { states } from "configs/states.config";
import { Dropdown, FilePicker, Input, Textarea } from "stories";
import { ConditionalFormRenderer } from "stories/components/FormRenderer/ConditionalFormRenderer";
import { OffSiteLandServicing } from "stories/components/offSiteLandServicing";
import { RadioGroupList } from "stories/components/radioGroup/RadioGroup";
import { staticEntities } from "../../constants";

export const constructionFields = [
  [
    {
      name: "country",
      component: Dropdown,
      props: {
        label: "Company Country",
        list: opportunityData.companyCountryList,
        disabled: true,
      },
    },
    {
      name: "state_or_province",
      component: Dropdown,
      props: (form) => {
        if (!form)
          return {
            label: "State/Province",
            disabled: true,
            list: [],
          };
        return {
          label: "State/Province",
          list: states[form.watch("country")],
          disabled: true,
        };
      },
    },
    {
      name: "city",
      component: Input,
      props: {
        label: "City",
        disabled: true,
      },
    },
  ],
  [
    {
      name: "address",
      component: Input,
      props: {
        label: "Street Address",
        disabled: true,
      },
    },
    {
      name: "postal_code",
      component: Input,
      props: {
        label: "Postal Code / Zip Code",
        disabled: true,
      },
    },
    {
      name: "google_map_url",
      component: Input,
      props: {
        label: "Google Map Location (Link)",
        disabled: true,
      },
    },
  ],
  [
    {
      name: "legal_description",
      component: Input,
      props: {
        label: "Legal Description",
      },
    },
    {
      name: "property_identification_number",
      component: Input,
      props: {
        label: "Property Identification Number",
      },
    },
    {},
  ],
  [
    {
      name: "land_title_document_filename",
      component: FilePicker,
      props: {
        label: "Land Title Document",
        type: "file",
      },
    },
    {
      name: "proposed_project_description",
      component: FilePicker,
      props: {
        label: "Proposed Project Description",
        type: "file",
      },
    },
  ],
  [
    {
      name: "servicing_been_completed",
      component: RadioGroupList,
      props: {
        label: "Servicing Completed?",
        list: servicingCompletedList,
      },
    },
    {},
    {},
  ],
  [
    {
      renderAsFormItem: false,
      component: ConditionalFormRenderer,
      props: {
        conditionFieldName: "servicing_been_completed",
        conditionalFields: {
          true: [
            [
              {
                name: "site_plans_filename",
                component: FilePicker,
                props: {
                  label: "Site Plans",
                  type: "file",
                },
              },
              {
                name: "site_plan_description",
                component: Textarea,
                props: {
                  label: "Site Plans Description",
                },
              },
            ],
            [
              {
                name: "current_zoning_specification",
                component: Input,
                props: {
                  label: "Current Zoning Specifications",
                },
              },
              {
                name: "permitted_density",
                component: Input,
                props: {
                  label: "Permitted Density",
                  type: "currency",
                },
              },
              {},
            ],
            [
              {
                name: "servicing_community_plan_filename",
                component: FilePicker,
                props: {
                  label: "Community Plan",
                  type: "file",
                },
              },
              {},
            ],
          ],
          false: [
            [
              {
                name: "site_servicing_plans_filename",
                component: FilePicker,
                props: {
                  label: "Site Servicing Plans",
                  type: "file",
                },
              },
              {
                name: "site_servicing_plan_description",
                component: Textarea,
                props: {
                  label: "Site Servicing Plan Description",
                },
              },
            ],
            [
              {
                name: "servicing_agreement_filename",
                component: FilePicker,
                props: {
                  label: "Servicing Agreement",
                  type: "file",
                },
              },
              {
                name: "municipality_servicing_agreement_description",
                component: Textarea,
                props: {
                  label: "Municipality Servicing Agreement Description",
                },
              },
            ],
            [
              {
                name: "site_servicing_contract",
                component: RadioGroupList,
                props: {
                  label: "Servicing Contract with Contractor In Place?",
                  list: staticEntities.booleanList,
                },
              },
            ],
            [
              {
                renderAsFormItem: false,
                component: ConditionalFormRenderer,
                props: {
                  conditionFieldName: "site_servicing_contract",
                  conditionalFields: {
                    true: [
                      [
                        {
                          name: "site_servicing_contract_filename",
                          component: FilePicker,
                          props: {
                            label: "Site Servicing Contract",
                            type: "file",
                          },
                        },
                        {
                          name: "site_servicing_contract_description",
                          component: Textarea,
                          props: {
                            label: "Contract Description",
                          },
                        },
                      ],
                      [
                        {
                          name: "off_site_land_servicing_to_be_built",
                          component: OffSiteLandServicing,
                          props: {},
                        },
                      ],
                      [
                        {
                          name: "site_plans_filename",
                          component: FilePicker,
                          props: {
                            label: "Site Plans",
                            type: "file",
                          },
                        },
                        {
                          name: "site_plan_description",
                          component: Textarea,
                          props: {
                            label: "Site Plans Description",
                          },
                        },
                      ],
                      [
                        {
                          name: "current_zoning_specification",
                          component: Input,
                          props: {
                            label: "Current Zoning Specifications",
                          },
                        },
                        {
                          name: "permitted_density",
                          component: Input,
                          props: {
                            label: "Permitted Density",
                            type: "currency",
                          },
                        },
                        {},
                      ],
                      [
                        {
                          name: "servicing_community_plan_filename",
                          component: FilePicker,
                          props: {
                            label: "Community Plan",
                          },
                        },
                        {},
                      ],
                    ],
                    false: [
                      [
                        {
                          name: "off_site_land_servicing_to_be_built",
                          component: OffSiteLandServicing,
                          props: {},
                        },
                      ],
                      [
                        {
                          name: "site_plans_filename",
                          component: FilePicker,
                          props: {
                            label: "Site Plans",
                            type: "file",
                          },
                        },
                        {
                          name: "site_plan_description",
                          component: Textarea,
                          props: {
                            label: "Site Plans Description",
                          },
                        },
                      ],
                      [
                        {
                          name: "current_zoning_specification",
                          component: Input,
                          props: {
                            label: "Current Zoning Specifications",
                          },
                        },
                        {
                          name: "permitted_density",
                          component: Input,
                          props: {
                            label: "Permitted Density",
                            type: "currency",
                          },
                        },
                        {},
                      ],
                      [
                        {
                          name: "servicing_community_plan_filename",
                          component: FilePicker,
                          props: {
                            label: "Community Plan",
                            type: "file",
                          },
                        },
                        {},
                      ],
                    ],
                  },
                },
              },
            ],
          ],
        },
      },
    },
  ],
  [
    {
      name: "site_area",
      component: Input,
      props: {
        label: "Site Area",
        type: "currency",
      },
    },
    {
      name: "gross_buildable_area",
      component: Input,
      props: {
        label: "Gross Buildable Area",
        type: "currency",
      },
    },
    {
      name: "fsr_far",
      component: Input,
      props: (form) => {
        const props = {
          label: "FSR/FAR",
          disabled: true,
          value: "-",
        };
        if (!form) return props;
        const [newGrossBuildableArea, siteArea] = form.watch([
          "gross_buildable_area",
          "site_area",
        ]);

        if (!isNaN(parseFloat(siteArea)) && parseFloat(siteArea) > 0) {
          const payload = !isNaN(parseFloat(newGrossBuildableArea))
            ? parseFloat(newGrossBuildableArea)
            : 0;
          props.value = Number((payload / parseFloat(siteArea)).toFixed(2));
        }

        return props;
      },
    },
  ],
  [
    {
      name: "gross_floor_area",
      component: Input,
      props: {
        label: "Gross Floor Area (GFA)",
        type: "currency",
      },
    },

    {
      name: "net_floor_area",
      component: Input,
      props: {
        label: "Net Floor Area (NFA)",
        type: "currency",
      },
    },
    {},
  ],
  [
    {
      name: "rezoning",
      component: RadioGroupList,
      props: {
        list: staticEntities.booleanList,
        label: "Rezoning?",
      },
    },
    {},
    {},
  ],
  [
    {
      renderAsFormItem: false,
      component: ConditionalFormRenderer,
      props: {
        conditionFieldName: "rezoning",
        conditionalFields: {
          true: [
            [
              {
                name: "new_zoning_specifications",
                component: Textarea,
                props: {
                  label: "New Zoning Specifications",
                },
              },
              {},
            ],
            [
              {
                name: "new_permitted_density",
                component: Input,
                props: {
                  label: "New Permitted Density",
                  type: "currency",
                },
              },
              {},
            ],
            [
              {
                name: "rezoning_community_plan_filename",
                component: FilePicker,
                props: {
                  label: "Community Plan",
                  type: "file",
                },
              },
              {
                name: "rezoning_application_filename",
                component: FilePicker,
                props: {
                  label: "Re-Zoning Application",
                  type: "file",
                },
              },
            ],
            [
              {
                name: "new_gross_buildable_area",
                component: Input,
                props: {
                  label: "New Gross Buildable Area",
                  type: "currency",
                },
              },
              {
                name: "new_fsr_far",
                component: Input,
                props: (form) => {
                  const props = {
                    label: "New FSR/FAR",
                    disabled: true,
                    value: "-",
                  };

                  if (!form) return props;

                  const [newGrossBuildableArea, siteArea] = form.watch([
                    "new_gross_buildable_area",
                    "site_area",
                  ]);

                  if (
                    !isNaN(parseFloat(siteArea)) &&
                    parseFloat(siteArea) > 0
                  ) {
                    const payload = !isNaN(parseFloat(newGrossBuildableArea))
                      ? parseFloat(newGrossBuildableArea)
                      : 0;
                    props.value = Number(
                      (payload / parseFloat(siteArea)).toFixed(2)
                    );
                  }

                  return props;
                },
              },
            ],
            [
              {
                name: "new_gross_floor_area",
                component: Input,
                props: {
                  label: "New Gross Floor Area (GFA)",
                  type: "currency",
                },
              },
              {
                name: "new_net_floor_area",
                component: Input,
                props: {
                  label: "New Net Floor Area (NFA)",
                  type: "currency",
                },
              },
            ],
          ],
          false: [],
        },
      },
    },
  ],
];
